import Duration from "@repo/utils/Duration";
import Organization from "./Organization.js";
import Money from "@repo/utils/Money";

export type Promotion = {
  id: Promotion.Id;
  name: string;
  unit: Promotion.Unit;
  value: number;
  organizationId: Organization.Id;
  startAt?: Date;
  endAt?: Date;
  duration?: Duration.String;
  updatedAt: Date;
  // This is temporary; we will replace this with a query for
  // more customization on which items the promotion applies to.
  itemTypes: Promotion.ItemType;
};

export namespace Promotion {
  export type Id = `pr_${string}`;
  export type ItemType = {
    booking: boolean;
    product: boolean;
    membership: boolean;
  };

  export const format = ({ unit, value }: { unit: Unit; value: number }) => {
    if (unit === "percent") {
      return `${value}%`;
    }
    return `${Money.format(value)}`;
  };

  export type Unit = (typeof units)[number];

  export const units = ["percent", "cents"] as const;

  export type Params = Pick<
    Promotion,
    "name" | "unit" | "value" | "startAt" | "endAt" | "duration" | "itemTypes"
  >;

  export namespace Params {
    export type Update = Pick<
      Params,
      "name" | "startAt" | "endAt" | "duration"
    >;
  }

  export type Code = {
    id: Code.Id;
    code: string;
    unit: Promotion.Unit;
    value: number;
    validFrom: Date;
    validTo?: Date;
    promotionId: Promotion.Id;
    organizationId: Organization.Id;
    uses?: number;
    itemTypes: Promotion.ItemType;
  };

  export namespace Code {
    export type Id = `pc_${string}`;

    export type Params = {
      uses?: number;
    } & (
      | {
          code: string;
        }
      | {
          generateCount: number;
        }
    );
  }
}
